import client from '../apiClient';

const getCatalog = ({ search = '', page = 0, size = 10, type = 'course', origin = '' } = {}) =>
    client.get(`/client-admin/catalog?search=${encodeURIComponent(search)}&page=${page}&size=${size}&type=${type}&origin=${origin}`);

const getContentBank = ({ search = '', page = 0, size = 10 } = {}) =>
    client.get(`/client-admin/content-bank?search=${encodeURIComponent(search)}&page=${page}&size=${size}`);

const assignContent = (data) =>
    client.post('/client-admin/catalog/assign', data);

const getAssignments = (sccpId, itemId = null) =>
    client.get(`/client-admin/catalog/assignments/${sccpId}${itemId != null ? `?itemId=${itemId}` : ''}`);

 const updateContentStatus = (itemId, type, status) =>
        client.patch(`/client-admin/content-bank/${itemId}/status`, { status, type });

export default { getCatalog, getContentBank, assignContent, getAssignments, updateContentStatus };
